import React, {useEffect, useState} from 'react';
import {Button, Typography} from 'components';
import Search from '@material-ui/icons/Search';

const styles = {
  filter: {
    width: '100%',
    maxWidth: '260px',
    paddingLeft: '24px',
  },
  filterInputBox: {
    marginBottom: '20px',
    marginTop: '20px',
    position: 'relative',
  },
  filterInput: {
    width: '100%',
    border: 'none',
    borderBottom: '1px solid',
    height: '40px',
    outline: 'none',
  },
  filterList: {
    margin: '0 0 20px',
    padding: 0,
    listStyle: 'none',
    maxHeight: 'calc(100vh - 343px)',
    overflowY: 'auto',
  },
  filterItem: {
    fontSize: '0.9rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    borderBottom: '1px solid #ccc',
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  filterIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
    height: '100%',
    width: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  filterNote: {
    fontSize: '0.8rem',
    margin: '0 0 20px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
};

export const FeaturesSidebar = (props) => {
  const [featuresList, setFeaturesList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [matchedFeaturesList, setMatchedFeaturesList] = useState([]);

  const onChangeHandler = (e) => {
    setSearchValue(e.target.value);
  };

  const onCheckedHandler = (e) => {
    setFeaturesList(
      featuresList.map((item) => {
        if (item.name === e.target.name) {
          item.isChecked = !item.isChecked;
        }
        return item;
      })
    );
  };

  const onAddFeaturesHandler = () => {
    props.addFeaturesToTable(featuresList.filter((item) => item.isChecked));
  };

  useEffect(() => {
    setFeaturesList(
      props.typesAndFeatures.map((item) => ({ ...item, isChecked: false }))
    );
  }, [props.typesAndFeatures]);

  useEffect(() => {
    setMatchedFeaturesList(featuresList);
  }, [featuresList]);

  useEffect(() => {
    const searchPattern = new RegExp(searchValue, 'gi');
    setMatchedFeaturesList(
      featuresList.filter((item) => item.name.match(searchPattern))
    );
  }, [searchValue]);

  if (!featuresList.length) return null;

  return (
    <div style={styles.filter}>
      <Typography variant="h6">Product components</Typography>
      <div style={styles.filterInputBox}>
        <input
          style={styles.filterInput}
          type="text"
          value={searchValue}
          onChange={onChangeHandler}
        />
        <div style={styles.filterIcon}>
          <Search />
        </div>
      </div>
      {!!matchedFeaturesList.length ? (
        <ul style={styles.filterList}>
          {matchedFeaturesList.map((item, index) => (
            <li key={`${item.name}-${index}`} style={styles.filterItem}>
              <label style={styles.filterLabel}>
                {item.name}
                <input
                  type="checkbox"
                  name={item.name}
                  checked={item.isChecked}
                  onChange={onCheckedHandler}
                />
              </label>
            </li>
          ))}
        </ul>
      ) : (
        <div style={styles.filterNote}>There are no matches!</div>
      )}

      <Button variant="outlined" color="primary" onClick={onAddFeaturesHandler}>
        Add
      </Button>
    </div>
  );
};
